export const styles = theme => ({
  tableWrapper: {
    overflowX: "auto"
  },
  frameTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "1.5rem"
  },
  frameGrid: {
    display: "flex",
    justifyContent: "space-between"
  },
  activeChip: {
    backgroundColor: "#2db253",
    color: "#fff"
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    // backgroundColor: fade('#9E9E9E', 0.15),
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.8)"
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto"
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex"
    // backgroundColor: '#eaeaea'
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit",
    width: "100%"
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200
      }
    }
  },
  tableCellInCollapes: {
    borderBottom: "none"
  }
});
export const details = theme => ({
  btnStatus: {
    width: "6rem",
    minWidth: 80,
    fontSize: "0.675rem"
  },
  root: {
    display: "block",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  title: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    textTransform: "capitalize"
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: "100%"
  }
});
